import React, { useState } from "react";
import axios from "axios";
import "./Login.css";
import logo from "../../assets/images/pedal.png";
import bike from "../../assets/images/pngegg.svg";
import { isTokenUsable, setAuthToken } from "../../utils/auth";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await axios.post(
        "https://www.euvoup14sports.com.br/api/login",
        { email, password }
      );

      const accessToken = response.data?.access_token;
      if (!isTokenUsable(accessToken)) {
        throw new Error("A API retornou uma sessão inválida.");
      }

      setAuthToken(accessToken);
      window.location.href = "/admin";
    } catch (err) {
      setError("Usuário ou senha inválidos");
    }
  };

  return (
    <main className="login-page" style={{ backgroundImage: `url(${logo})` }}>
      <div className="login-page-overlay" aria-hidden="true" />

      <div className="login-layout">
        <section className="login-intro" aria-labelledby="login-brand-title">
          <div className="login-brand login-brand-light">
            <span className="login-brand-icon">
              <img src={bike} alt="" />
            </span>
            <span>EUVOUP14SPORTS</span>
          </div>

          <div className="login-intro-content">
            <span className="login-eyebrow">P14 Sports</span>
            <h1 id="login-brand-title">
              Somos a P14 Sports
              <span>Experiências que conectam. Movimentos que transformam.</span>
            </h1>

            <div className="login-story">
              <p>
                O esporte é sobre movimento. Movimento que inspira, conecta,
                transforma e deixa marcas que vão muito além da linha de chegada.
              </p>
              <p>
                Na P14 Sports, cada evento é uma oportunidade de desafiar seus
                limites, descobrir novos destinos e criar memórias para a vida toda.
              </p>
              <p>A próxima história pode ser a sua.</p>
            </div>

            <ul className="login-benefits">
              <li>Adicione seu nome ou apelido</li>
              <li>Destaque sua cidade e sua origem</li>
              <li>Escolha sua foto e compartilhe sua jornada</li>
            </ul>
          </div>

          <p className="login-signature">P14 Sports — agência em movimento.</p>
        </section>

        <section className="login-access" aria-labelledby="login-title">
          <div className="login-card">
            <div className="login-brand login-brand-card">
              <span className="login-brand-icon">
                <img src={bike} alt="" />
              </span>
              <span>EUVOUP14SPORTS</span>
            </div>

            <div className="login-card-heading">
              <span className="login-card-kicker">Área administrativa</span>
              <h2 id="login-title">Bem-vindo de volta</h2>
              <p>Entre com suas credenciais para gerenciar os eventos.</p>
            </div>

            <form className="login-form" onSubmit={handleLogin}>
              <div className="login-field">
                <label htmlFor="email">E-mail</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  maxLength={254}
                  id="email"
                  autoComplete="email"
                  placeholder="nome@empresa.com.br"
                />
              </div>

              <div className="login-field">
                <label htmlFor="password">Senha</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  maxLength={128}
                  id="password"
                  autoComplete="current-password"
                  placeholder="Digite sua senha"
                />
              </div>

              {error && (
                <p className="login-error" role="alert">
                  {error}
                </p>
              )}

              <button type="submit" className="login-submit">
                Entrar
              </button>
            </form>

            <p className="login-card-footer">Acesso exclusivo para a equipe P14 Sports</p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Login;
